<template>
  <div>
    <div v-if="isLogin">
      <div v-if="userInfo.vip_status==1" :class="['vip-status-card',margin?'right-inn':'']" @click="goToVip">
        <!-- 如果是会员 -->
        <div class="vip-status-header" v-if="userInfo.member_type==1">
          <div class="vip-status-icon">
            <i class="el-icon-star-on"></i>
          </div>
          <div class="vip-status-info">
            <h3>VIP会员</h3>
            <div class="vip-expire-info">
              <span class="expire-label">会员有效期：</span>
              <span class="expire-date">{{ userInfo.vip_end_at || '--' }}</span>
            </div>
          </div>
        </div>
        <!-- 如果是超级会员 -->
        <div class="vip-status-header" v-if="userInfo.member_type==2">
          <div class="vip-status-icon">
            <i class="el-icon-star-on"></i>
          </div>
          <div class="vip-status-info">
            <h3>SVIP会员</h3>
            <div class="vip-expire-info">
              <span class="expire-label">会员有效期：</span>
              <span class="expire-date">{{ userInfo.vip_end_at || '--' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 如果是非会员 -->
      <div :class="['vip-recharge-section',margin?'right-inn':'']" v-else>
        <!-- 如果线下付款会员 -->
        <div v-if="userInfo.vip_status!=1&&userInfo.member_pay_submit" class="vip-card" @click="goToVip">
          <div class="vip-card-header">
            <div class="vip-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="vip-title">
              <h3>您的{{ userInfo.member_type == 1 ? 'vip' : 'svip' }}订单
                <span v-if="userInfo.member_audit_status==1">审核中</span>
                <span v-else>审核失败</span>
              </h3>
            </div>
          </div>
        </div>
        <div v-else class="vip-card" @click="goToVip">
          <div class="vip-card-header">
            <div class="vip-icon">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="vip-title">
              <h3>升级VIP会员</h3>
              <p>享受专属特权服务</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div :class="['vip-recharge-section',margin?'right-inn':'']" @click="goAbout">
        <!-- 如果线下付款会员 -->
        <div class="vip-card vip-card-free">
          <div class="vip-card-header">
            <div class="vip-icon">
              <i class="el-icon-s-flag"></i>
            </div>
            <div class="vip-title">
              <h3>免费入驻</h3>
              <p>精准匹配，高效服务</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'vipStatus',
  props: {
    margin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'is_vip', 'isLogin']),
  },
  methods: {
    goToVip() {
      let userInfo = this.userInfo
      // 如果没有支付过vip
      if (userInfo.vip_status == 2) {
        if (userInfo.member_audit_status == -1) {
          this.$router.push({path: '/vip/vip'});
        } else {
          this.$router.push({path: '/vip/vipSuc'});
        }
      } else {
        // 如果是vip
        if (userInfo.member_type == 1) {
          if (userInfo.member_audit_status == 1) {
            this.$router.push({path: '/vip/svipSuc'});
          } else {
            this.$router.push({path: '/vip/vipSuc'});
          }
        } else {
          this.$router.push({path: '/vip/svipSuc'});
        }


      }
    },
    goAbout() {
      this.$router.push({path: '/about-us'});
    }
  }
}
</script>
<style scoped lang="scss">
.right-inn {
  margin-right: 20px;
}

.vip-card-free {
  background: linear-gradient(90deg, #223bc5 0%, #4facfe 100%);
}

.vip-status-card {
  background: linear-gradient(135deg, #4facfe 0%, #223bc5 100%);
  border-radius: 10px;
  padding: 5px 20px;
  color: white;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    padding: 16px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 32px rgba(74, 222, 128, 0.4);
  }

  .vip-status-header {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    @media (max-width: 768px) {
      margin-bottom: 12px;
    }

    .vip-status-icon {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      @media (max-width: 768px) {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }

      i {
        font-size: 20px;
        color: #ffd700;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
    }

    .vip-status-info {
      display: flex;
      white-space: nowrap;

      h3 {
        margin: 0 0 2px 0;
        font-size: 16px;
        font-weight: 600;
        color: white;
        margin-right: 5px;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      p {
        margin: 0;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);

        @media (max-width: 768px) {
          font-size: 11px;
        }
      }
    }
  }

  .vip-status-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .vip-expire-info {
      font-size: 12px;

      .expire-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);

        @media (max-width: 768px) {
          font-size: 11px;
        }
      }

      .expire-date {
        font-size: 12px;
        font-weight: 600;
        color: white;
        margin-left: 4px;

        @media (max-width: 768px) {
          font-size: 12px;
        }
      }
    }

    .vip-action {
      .el-button {
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.3);
        color: white;
        font-weight: 500;

        @media (max-width: 768px) {
          font-size: 12px;
          padding: 6px 12px;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.3);
          border-color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }
}

.vip-recharge-section {
  flex: 1;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    margin-right: 0;
    order: 1;
  }

  .vip-card {
    background: linear-gradient(135deg, #2f67ff 0%, #4facfe 100%);
    border-radius: 10px;
    padding: 10px 20px;
    color: white;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
    position: relative;
    right: 0;
    overflow: hidden;

    @media (max-width: 768px) {
      padding: 16px;
    }

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: shimmer 3s infinite;
    }

    @keyframes shimmer {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 40px rgba(102, 126, 234, 0.4);
    }

    .vip-card-header {
      display: flex;
      align-items: center;

      @media (max-width: 768px) {
        margin-bottom: 16px;
      }

      .vip-icon {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;

        @media (max-width: 768px) {
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }

        i {
          font-size: 24px;
          color: #ffd700;

          @media (max-width: 768px) {
            font-size: 20px;
          }
        }
      }

      .vip-title {
        display: flex;
        white-space: nowrap;
        align-items: center;

        h3 {
          margin: 0 0 4px 0;
          font-size: 14px;
          font-weight: 600;
          color: white;
          margin-right: 5px;

          @media (max-width: 768px) {
            font-size: 14px;
          }
        }

        p {
          margin: 0;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);

          @media (max-width: 768px) {
            font-size: 12px;
          }
        }
      }
    }

    .vip-card-content {
      .vip-benefits {
        margin-bottom: 20px;

        @media (max-width: 768px) {
          margin-bottom: 16px;
        }

        .benefit-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          font-size: 14px;

          @media (max-width: 768px) {
            font-size: 12px;
            margin-bottom: 6px;
          }

          i {
            color: #4ade80;
            margin-right: 8px;
            font-size: 16px;

            @media (max-width: 768px) {
              font-size: 14px;
              margin-right: 6px;
            }
          }

          span {
            color: rgba(255, 255, 255, 0.9);
          }
        }
      }

      .vip-action {
        .vip-upgrade-btn {
          background: linear-gradient(45deg, #ffd700, #ffed4e);
          border: none;
          color: #333;
          font-weight: 600;
          padding: 12px 24px;
          border-radius: 8px;
          transition: all 0.3s ease;

          @media (max-width: 768px) {
            padding: 10px 20px;
            font-size: 14px;
          }

          i {
            margin-right: 6px;
            color: #333;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(255, 215, 0, 0.4);
          }
        }
      }
    }
  }

  .vip-status-card {
    float: right;
    background: linear-gradient(135deg, #4ad4de 0%, #223bc5 100%);
    border-radius: 10px;
    padding: 5px 20px;
    color: white;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      padding: 16px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 32px rgba(74, 222, 128, 0.4);
    }

    .vip-status-header {
      display: flex;
      align-items: center;
      padding: 5px 10px;

      @media (max-width: 768px) {
        margin-bottom: 12px;
      }

      .vip-status-icon {

        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;

        @media (max-width: 768px) {
          width: 32px;
          height: 32px;
          margin-right: 8px;
        }

        i {
          font-size: 20px;
          color: #ffd700;

          @media (max-width: 768px) {
            font-size: 16px;
          }
        }
      }

      .vip-status-info {
        display: flex;
        white-space: nowrap;

        h3 {
          margin: 0 0 2px 0;
          font-size: 16px;
          font-weight: 600;
          color: white;
          margin-right: 5px;

          @media (max-width: 768px) {
            font-size: 16px;
          }
        }

        p {
          margin: 0;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);

          @media (max-width: 768px) {
            font-size: 11px;
          }
        }
      }
    }

    .vip-status-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }

      .vip-expire-info {
        font-size: 12px;

        .expire-label {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);

          @media (max-width: 768px) {
            font-size: 11px;
          }
        }

        .expire-date {
          font-size: 12px;
          font-weight: 600;
          color: white;
          margin-left: 4px;

          @media (max-width: 768px) {
            font-size: 12px;
          }
        }
      }

      .vip-action {
        .el-button {
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.3);
          color: white;
          font-weight: 500;

          @media (max-width: 768px) {
            font-size: 12px;
            padding: 6px 12px;
          }

          &:hover {
            background: rgba(255, 255, 255, 0.3);
            border-color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
  }
}

</style>
